import styled from 'styled-components';
import theme from '../../assets/styles/theme';

export const AppContentWrapper = styled.div`
  padding: ${theme.spacing['spacing-5']} ${theme.spacing['spacing-7']};
`;
export const AppContent = styled.div`
  margin: ${theme.spacing['spacing-0']} auto;
`;
